<script setup lang="ts">
import { computed } from 'vue'
import { type Unit } from '@/types/basic'
import type { TUiTypeValues, UiColor } from '../../../types/api/reports'
import { severityToColor } from './gwTableUtils'
import { numKtoM } from '../../../helpers/formating'

const props = defineProps<{
  value: TUiTypeValues['big_blind']
  unit: Unit
  severities?: UiColor[]
  isTableValue?: boolean
}>()

const color = computed(() => severityToColor(props.severities)(Number(props.value)))
</script>

<template>
  <div
    class="truncate"
    :style="isTableValue ? { color } : ''"
  >
    {{ value && numKtoM(Number(value), 1_000, 2) }}
  </div>
</template>
